import { render, staticRenderFns } from "./custom-logo.vue?vue&type=template&id=6561df20&"
import script from "./custom-logo.vue?vue&type=script&lang=js&"
export * from "./custom-logo.vue?vue&type=script&lang=js&"
import style0 from "./custom-logo.vue?vue&type=style&index=0&id=6561df20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports